import { render, staticRenderFns } from "./app-page-header.vue?vue&type=template&id=925d0448&scoped=true&"
import script from "./app-page-header.vue?vue&type=script&lang=js&"
export * from "./app-page-header.vue?vue&type=script&lang=js&"
import style0 from "./app-page-header.vue?vue&type=style&index=0&id=925d0448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925d0448",
  null
  
)

export default component.exports